import { Navigate, Route, Routes } from "react-router-dom";
import { PeopleDashboardPage } from "@/features/People/Dashboard/PeopleDashboardPage";
import { EvaluationsListPage } from "@/features/People/Evaluations/pages/EvaluationsListPage";
import { CreateEvaluationPage } from "@/features/People/Evaluations/pages/CreateEvaluationPage";
import { QuestionnairesListPage } from "@/features/People/Evaluations/pages/QuestionnairesListPage";
import { QuestionnaireBuilderPage } from "@/features/People/Evaluations/pages/QuestionnaireBuilderPage";
import { ScalesPage } from "@/features/People/Evaluations/pages/ScalesPage";
import { EvaluationDetailsPage } from "@/features/People/Evaluations/pages/EvaluationDetailsPage";
import { EvaluationCollaboratorResultPage } from "@/features/People/Evaluations/pages/EvaluationCollaboratorResultPage";
import { EvaluationCollaboratorPrintReportPage } from "@/features/People/Evaluations/pages/EvaluationCollaboratorPrintReportPage";
import { PeopleLayout } from "@/features/People/Layout/PeopleLayout";
import { RoleBasedRoute } from "..";
import { ROLE_COMBINATIONS } from "@/router/proxyRouter.definitions";
import { ROLE_EVALUATION_ADMIN, useAuth } from "@/contexts/AuthContext";

function PeopleEntryPage() {
    const { userHasRole } = useAuth();

    if (userHasRole(ROLE_EVALUATION_ADMIN) && !ROLE_COMBINATIONS.COLLABORATOR_ACCESS.some((role) => userHasRole(role))) {
        return <Navigate to="/people/evaluations" replace />;
    }

    return <PeopleDashboardPage />;
}

export function PeopleRoutes() {
    return (
        <Routes>
            <Route element={<PeopleLayout />}>
                <Route
                    index
                    element={
                        <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.PEOPLE_ACCESS}>
                            <PeopleEntryPage />
                        </RoleBasedRoute>
                    }
                />

                {/* Evaluations Module */}
                <Route path="evaluations">
                    <Route
                        index
                        element={
                            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.EVALUATION_ACCESS}>
                                <EvaluationsListPage />
                            </RoleBasedRoute>
                        }
                    />
                    <Route
                        path=":id/results/:collaboratorId/report"
                        element={
                            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.EVALUATION_ACCESS}>
                                <EvaluationCollaboratorPrintReportPage />
                            </RoleBasedRoute>
                        }
                    />
                    <Route
                        path=":id/results/:collaboratorId"
                        element={
                            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.EVALUATION_ACCESS}>
                                <EvaluationCollaboratorResultPage />
                            </RoleBasedRoute>
                        }
                    />
                    <Route
                        path=":id"
                        element={
                            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.EVALUATION_ACCESS}>
                                <EvaluationDetailsPage />
                            </RoleBasedRoute>
                        }
                    />
                    <Route
                        path="new"
                        element={
                            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.EVALUATION_ACCESS}>
                                <CreateEvaluationPage />
                            </RoleBasedRoute>
                        }
                    />
                    <Route
                        path=":id/edit"
                        element={
                            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.EVALUATION_ACCESS}>
                                <CreateEvaluationPage />
                            </RoleBasedRoute>
                        }
                    />

                    {/* Questionnaires Module */}
                    <Route path="questionnaires">
                        <Route
                        index
                        element={
                            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.EVALUATION_ACCESS}>
                                <QuestionnairesListPage />
                            </RoleBasedRoute>
                        }
                    />
                    <Route
                        path="new"
                        element={
                            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.EVALUATION_ACCESS}>
                                <QuestionnaireBuilderPage />
                            </RoleBasedRoute>
                        }
                    />
                    <Route
                        path=":id"
                        element={
                            <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.EVALUATION_ACCESS}>
                                <QuestionnaireBuilderPage />
                            </RoleBasedRoute>
                        }
                    />
                    </Route>

                    {/* Scales Module */}
                    <Route path="scales" element={
                        <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.EVALUATION_ACCESS}>
                            <ScalesPage />
                        </RoleBasedRoute>
                    } />
                </Route>
            </Route>

            <Route path="*" element={<Navigate to="/people" replace />} />
        </Routes>
    );
}
